import { createAuthenticatedApi } from './apiInterceptors';

export interface SuggestionData {
  type: 'feature' | 'improvement' | 'bug' | 'general';
  title: string;
  message: string;
}

export interface SuggestionResponse {
  message: string;
}

const api = createAuthenticatedApi();

/**
 * Submit a suggestion to the server
 */
export const submitSuggestion = async (data: SuggestionData): Promise<SuggestionResponse> => {
  const response = await api.post<SuggestionResponse>('/suggestions', data);
  return response.data;
};
